// Full updated App.jsx with working image upload during new arrival creation

import React, { useEffect, useState } from 'react';
import { Routes, Route, Link } from 'react-router-dom';

import AboutUs from './AboutUs';
import ConcertPhotos from './ConcertPhotos';
import Login from './Login';
import RecordCard from './components/RecordCard';
import StorePhotos from './StorePhotos';
import AnimalVisitors from './AnimalVisitors';
import EmployeeOfTheMonth from './EmployeeOfTheMonth';
import RCRScholarships from './RCRScholarships';
import FullInventory from './components/FullInventory';
import LogRocket from 'logrocket';

LogRocket.init('w1tbmk/rasta-cowboy');

const App = () => {
  const [inventory, setInventory] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchInput, setSearchInput] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFormats, setSelectedFormats] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newArrivalTitle, setNewArrivalTitle] = useState('');
  const [newArrivalArtist, setNewArrivalArtist] = useState('');
  const [newArrivalFormat, setNewArrivalFormat] = useState('');
  const [newArrivalImage, setNewArrivalImage] = useState('');
  const itemsPerPage = 50;
  const CLOUD_NAME = 'dnybxda3y';
  const UPLOAD_PRESET = 'concert_photos';

  const [showAllNewArrivals, setShowAllNewArrivals] = useState(false);
  const matchesSearch = (text, input) => {
    if (text == null || input == null) return false;
    return text.toString().toLowerCase().includes(input.toLowerCase());
  };  

  const [cardsPerRow, setCardsPerRow] = useState(1);

  useEffect(() => {
    console.log('showAllNewArrivals changed:', showAllNewArrivals);
  }, [showAllNewArrivals]);
  

  useEffect(() => {
    const calculateCardsPerRow = () => {
      const gridWidth = document.querySelector('.grid')?.offsetWidth || window.innerWidth;
      const approxCardWidth = 220; // Card + gap estimate
      setCardsPerRow(Math.floor(gridWidth / approxCardWidth));
    };

    calculateCardsPerRow();
    window.addEventListener('resize', calculateCardsPerRow);
    return () => window.removeEventListener('resize', calculateCardsPerRow);
  }, []);


  const allowedFormats = ['12 inch', '33', '45', '78', 'CD', 'DVD', 'Cassette', 'Book'];

  const normalizeFormat = (format) => {
    const cleaned = format?.toString().trim().toLowerCase();
    if (cleaned === '12') return '12 inch';
    if (cleaned === 'cd') return 'CD';
    if (cleaned === 'cassette') return 'Cassette';
    if (cleaned === 'dvd') return 'DVD';
    if (cleaned === 'book') return 'Book';
    if (cleaned === '33') return '33';
    if (cleaned === '45') return '45';
    return null;
  };

  const fetchInventory = () => {
    fetch('api/data')
      .then(res => res.json())
      .then(data => {
        const cleaned = data.map(item => {
          const normalized = normalizeFormat(item.Format);
          if (!normalized || !item.Title || !item.Artist) return null;
          return { ...item, Format: normalized };
        }).filter(Boolean);        
        setInventory(cleaned);
      });
  };

  const fetchNewArrivals = () => {
    fetch('/api/new-arrivals')
      .then(res => res.json())
      .then(data => {
        console.log('Fetched from backend:', data.length); 
        console.log(data); // See the actual records
        setNewArrivals(data.reverse());
      })
      .catch(err => console.error('Error fetching new arrivals:', err));
  };
  

  useEffect(() => {
    fetchInventory();
    fetchNewArrivals();
  }, []);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);
  
    try {
      const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
        method: 'POST',
        body: formData,
      });
  
      const data = await res.json();
      const transformedURL = data.secure_url.replace('/upload/', '/upload/w_500,c_fit,q_auto,f_auto/');
  
      setNewArrivalImage(transformedURL);
    } catch (err) {
      console.error('Cloudinary Upload Error:', err);
    }
  };

  const handleAddNewArrival = async () => {
    if (!newArrivalTitle || !newArrivalArtist || !newArrivalFormat || !newArrivalImage) return;

    const payload = {
      Title: newArrivalTitle,
      Artist: newArrivalArtist,
      Format: newArrivalFormat,
      Image: newArrivalImage
    };

    const res = await fetch('/api/add-new-arrival', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (res.ok) {
      fetchNewArrivals();
      setShowModal(false);
      setNewArrivalTitle('');
      setNewArrivalArtist('');
      setNewArrivalFormat('');
      setNewArrivalImage('');
    }
  };

  const startsWithWord = (text, input) => {
    if (!text || !input) return false;
    return text.toLowerCase().split(' ').some(word => word.startsWith(input.toLowerCase()));
  };

  const filteredInventory = (selectedFormats.length ? inventory.filter(i => selectedFormats.includes(i.Format)) : inventory.filter(i => allowedFormats.includes(i.Format)))
  .filter(item =>
    !searchTerm ||
    matchesSearch(item.Title, searchTerm) ||
    matchesSearch(item.Artist, searchTerm) ||
    matchesSearch(item['#'], searchTerm) ||
    matchesSearch(item['S/N'], searchTerm)
);
  const totalPages = Math.ceil(filteredInventory.length / itemsPerPage);

  return (
    <div>
      <div className="banner-header">
        <div className="dropdown">
          <button type="button" className="dropbtn">&#9776;</button>
          <div className="dropdown-content">
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/concerts">Concert Photos</Link>
            <Link to="/store">Store Photos</Link>
            <Link to="/animals">Animal Visitors</Link>
            <Link to="/employees">Employee Of The Month</Link>
            <Link to="/scholarship">RCR Scholarships</Link>
          </div>
        </div>
        <img src="banner.jpg" alt="Banner" />
        <div style={{ position: 'absolute', top: 20, right: 20 }}>
          {localStorage.getItem('isAdmin') === 'true' ? (
            <button
              type="button"
              className="login-nav-button"
              onClick={() => { localStorage.removeItem('isAdmin'); window.location.href = '/'; }}
            >
              Sign Out
            </button>
          ) : (
            <Link to="/login" className="login-nav-button">
              Login
            </Link>
          )}
        </div>
      </div>

      <Routes>
        <Route path="/" element={
          <>
            <section className="section">
              <h2>New Arrivals</h2>
              <div className={`grid ${showAllNewArrivals ? 'expanded' : 'limited'}`}>
                {newArrivals.map((item, i) => (
                  <RecordCard key={i} data={item} refreshNewArrivals={fetchNewArrivals} />
                ))}
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px', flexWrap: 'wrap' }}>
              {!showAllNewArrivals && (
                <button type="button" className="view-new-arrivals-button" onClick={() => setShowAllNewArrivals(true)}>
                  View All New Arrivals
                </button>
              )}
              {localStorage.getItem('isAdmin') === 'true' && <button type="button" className="view-new-arrivals-button" onClick={() => setShowModal(true)}>+ Add New Arrival</button>}
              </div>
            </section>

            <FullInventory filteredInventory={filteredInventory} selectedFormats={selectedFormats} uniqueFormats={Array.from(new Set(inventory.map(i => i.Format))).sort()} toggleFormat={(format) => setSelectedFormats(p => p.includes(format) ? p.filter(f => f !== format) : [...p, format])} searchInput={searchInput} setSearchInput={setSearchInput} searchTerm={searchTerm} setSearchTerm={setSearchTerm} currentPage={currentPage} setCurrentPage={setCurrentPage} itemsPerPage={itemsPerPage} totalPages={totalPages} refreshInventory={fetchInventory} />
          </>
        } />

        <Route path="/about" element={<AboutUs />} />
        <Route path="/concerts" element={<ConcertPhotos />} />
        <Route path="/store" element={<StorePhotos />} />
        <Route path="/animals" element={<AnimalVisitors />} />
        <Route path="/employees" element={<EmployeeOfTheMonth />} />
        <Route path="/scholarship" element={<RCRScholarships />} />
        <Route path="/login" element={<Login />} />
      </Routes>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="record-card" style={{ width: '300px', padding: '15px', textAlign: 'center', cursor: 'default' }} onClick={(e) => e.stopPropagation()}>
            <p><strong>Artist:</strong><br /><input type="text" placeholder="Artist" value={newArrivalArtist} onChange={e => setNewArrivalArtist(e.target.value)} /></p>
            <p><strong>Title:</strong><br /><input type="text" placeholder="Title" value={newArrivalTitle} onChange={e => setNewArrivalTitle(e.target.value)} /></p>
            <p><strong>Format:</strong><br /><input type="text" placeholder="Format" value={newArrivalFormat} onChange={e => setNewArrivalFormat(e.target.value)} /></p>
            <p><strong>Image:</strong><br /><input type="file" accept="image/*" onChange={handleImageChange} /></p>
            <button type="button" className="view-new-arrivals-button" style={{ marginTop: '10px' }} onClick={handleAddNewArrival}>Submit</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
